<div *ngIf="Heading">
  <div class="add-record-menu" >
    <span class="menu-heading">{{ Heading }}</span>
    <span class="close" (click)="closeCaseCreation()">X</span>
  </div>
</div>

<div class="container">
  <div *ngIf="showSearch == true">
    <app-search-dialog
      (selectedSearchedItem)="handleSelectedExisistingUser($event)"
      (notFoundAddNew)="handleSelectedUser($event)" [hideNotFoundButton]="false"
    ></app-search-dialog>
  </div>
</div>
